const DEV = process.env.NODE_ENV === 'development'

export default {
  init() {
    if (window.LIVE_COVERAGE) {
      // set relative time for all live blocks
      setRelativeTime()
      // set js task to update date with relative time, use the function getRelativeTime, if "false" do not update
      setInterval(setRelativeTime, 60000) // 1 minuto

      ///console.log('Live Coverage ON')
      //setInterval(checkLiveUpdates, 40000) // 20 secondi
      setInterval(checkLiveUpdates, 360000) // 6 minuti

      this.setupClickHandler() // Inizializza l'event listener per load more e show updates
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    //console.log('finalize common');
  },
  setupClickHandler() {
    document.body.addEventListener('click', (e) => {
      const loadMoreBtn = e.target.closest('.js-live-news-load-more')
      const showUpdatesBtn = e.target.closest('#showUpdatesBtn')

      // loadmore è il bottone per caricare più contenuti che appare agli utenti loggati
      if (loadMoreBtn) {
        e.preventDefault()
        handleLoadMoreClick(loadMoreBtn)
      }

      // showUpdatesBtn è il bottone per mostrare gli aggiornamenti "futuri"
      if (showUpdatesBtn) {
        showUpdatesBtn.setAttribute('disabled', 'true')
        showUpdatesBtn.classList.add('opacity-50')
        showUpdates()
      }

      fixTwitterFeed()
    })
  },
}

function getPostId() {
  const article = document.querySelector('#primary article[id^="post-"]')
  return article ? article.id.replace('post-', '') : false
}

function setRelativeTime() {
  document.querySelectorAll('.live-block[data-published]').forEach((block) => {
    const publishedDate = block.getAttribute('data-published')
    const relativeTime = getRelativeTime(publishedDate)
    if (relativeTime)
      block.querySelector('.live-block-date').textContent = relativeTime
  })
}

function getRelativeTime(dateString) {
  const now = new Date()
  const published = new Date(dateString)
  const diffInSeconds = Math.floor((now - published) / 1000)

  if (diffInSeconds < 0 || diffInSeconds > 86400) return false

  const intervals = {
    year: 31536000,
    month: 2592000,
    week: 604800,
    day: 86400,
    hour: 3600,
    minute: 60,
    second: 1,
  }
  // prendiamo lingua del browser
  const locale = document.documentElement.lang || navigator.language || 'en'

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })

  for (const [unit, secondsInUnit] of Object.entries(intervals)) {
    const delta = Math.floor(diffInSeconds / secondsInUnit)
    if (Math.abs(delta) >= 1) {
      // appena troviamo un'unità di tempo che ha un delta maggiore di 1, la usiamo
      return rtf.format(-delta, unit)
    }
  }
  // se non troviamo un delta utile vuol dire che è aggiornamento in tempo reale
  return rtf.format(0, 'second')
}

/**
 * Checks for live updates by fetching the current page's HTML and comparing
 * the '.live-block[data-published]' elements with the ones in the fetched HTML.
 * If new live blocks are found, they are inserted into the '.article-body'
 * of the current page. The '.mux-player-wrapper' divs are preserved and not
 * replaced during this process.
 *
 * @function checkLiveUpdates
 * @returns {void}
 */
function checkLiveUpdates() {
  console.log('Checking for live updates...')
  const postId = getPostId()

  const formData = new FormData()
  formData.append('action', 'live_news_load_more_content')
  formData.append('post_id', postId)
  formData.append('transient_id', 1)
  formData.append('load_more', false)

  fetch(cnArgs.ajaxUrl, { method: 'POST', body: formData })
    .then((res) => res.json())
    .then((html) => {
      const parser = new DOMParser()
      const doc = parser.parseFromString(html.data, 'text/html')

      const newBlocks = doc.querySelectorAll('.live-block[data-published]')
      const currentBlocks = document.querySelectorAll(
        '.live-block[data-published]'
      )
      const currentDates = Array.from(currentBlocks).map((b) =>
        b.getAttribute('data-published')
      )

      // Confronta i blocchi esistenti con quelli nuovi
      const updates = Array.from(newBlocks).filter(
        (b) => !currentDates.includes(b.getAttribute('data-published'))
      )

      if (updates.length > 0) {
        document.getElementById('updates-number').textContent = updates.length
        document
          .querySelectorAll('.updates-notification')
          .forEach((el) => el.classList.remove('hidden'))
      }
    })
    .catch((err) => console.error('Error fetching live updates:', err))
}

function handleLoadMoreClick(button) {
  const postId = button.getAttribute('data-post-id')
  const transientId = button.getAttribute('data-transient-id')

  button.style.display = 'none'
  button.parentElement.style.display = 'none'
  button
    .closest('.live-block-container')
    ?.querySelector('.load-more-spinner')
    ?.classList.remove('hidden')

  const formData = new FormData()
  formData.append('action', 'live_news_load_more_content')
  formData.append('post_id', postId)
  formData.append('transient_id', transientId)
  formData.append('load_more', true)

  fetch(cnArgs.ajaxUrl, { method: 'POST', body: formData })
    .then((res) => res.json())
    .then((data) => {
      if (data.success) {
        insertNewBlocks(data.data, 'append', false)
        button
          .closest('.live-block-container')
          ?.querySelector('.load-more-spinner')
          ?.classList.add('hidden')
      } else {
        console.error('Errore:', data.data)
      }
    })
    .catch((err) => console.error('Errore nella richiesta AJAX:', err))
}

function showUpdates() {
  document
    .querySelectorAll('.updates-notification')
    .forEach((el) => el.classList.add('hidden'))
  const postId = getPostId()
  const formData = new FormData()
  formData.append('action', 'live_news_load_more_content')
  formData.append('post_id', postId)
  formData.append('transient_id', 1)

  fetch(cnArgs.ajaxUrl, { method: 'POST', body: formData })
    .then((res) => res.json())
    .then((html) => {
      insertNewBlocks(html.data, 'prepend', true)
    })
    .catch((err) => console.error('Error fetching live updates:', err))
}

function insertNewBlocks(htmlContent, mode = 'append', allowReload = true) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlContent, 'text/html')
  const newBlocks = doc.querySelectorAll('.live-block[data-published]')
  const currentBlocks = document.querySelectorAll('.live-block[data-published]')
  const currentDates = Array.from(currentBlocks).map((b) =>
    b.getAttribute('data-published')
  )

  const container = document.createDocumentFragment()
  let firstBlockId = null
  let updatesCount = 0

  newBlocks.forEach((block) => {
    const published = block.getAttribute('data-published')
    if (!currentDates.includes(published)) {
      updatesCount++

      if (block.dataset.forceReload === 'true' && allowReload) {
        forceReload()
        return
      }

      const clone = block.cloneNode(true)
      fixCopyUrlButtons(clone)

      const fragment = document.createDocumentFragment()
      fragment.appendChild(clone)

      let next = block.nextElementSibling
      while (next && !next.classList.contains('live-block')) {
        fragment.appendChild(next.cloneNode(true))
        next = next.nextElementSibling
      }

      if (updatesCount === 1) firstBlockId = '#' + clone.id
      container.appendChild(fragment)
    }
  })

  if (updatesCount > 0) {
    const target = document.querySelector('.article-body')
    if (mode === 'prepend') {
      target.insertBefore(container, document.querySelector('.live-block'))
    } else {
      target.appendChild(container)
    }

    document.getElementById('showUpdatesBtn')?.removeAttribute('disabled')
    document.getElementById('showUpdatesBtn')?.classList.remove('opacity-50')

    if (typeof twttr !== 'undefined') twttr.widgets.load()

    if (mode === 'prepend' && firstBlockId) {
      window.scrollTo({
        top: document.querySelector(firstBlockId).offsetTop - 200,
        behavior: 'smooth',
      })
    }
  }
  // convert dates
  setRelativeTime()
}

function fixCopyUrlButtons(scope) {
  scope.querySelectorAll('.copy-url-at').forEach((btn) => {
    const block = btn.closest('.live-block')
    if (block?.id) {
      const cleanUrl = `${window.location.origin}${window.location.pathname}`
      btn.setAttribute('data-url', `${cleanUrl}?f=true#${block.id}`)
    }
  })
}

function forceReload() {
  window.location.reload(true)
}

function fixTwitterFeed() {
  // fix twitter not rendering correctly
  if (typeof twttr !== 'undefined') {
    twttr.widgets.load()
  } else {
    var script = document.createElement('script')
    script.src = 'https://platform.twitter.com/widgets.js'
    script.async = true
    document.body.appendChild(script)
  }
}
